import axiosBase from "../axiosBase";

export const apiLoadInteriorMain = () =>
  axiosBase.get("block/page/main?parent=interiorMain");
export const apiLoadInteriorBlock = () =>
  axiosBase.get("block/page/blocks?parent=interior");
